import { Component, OnInit, Input, Inject, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { Location, CurrencyPipe } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService, ConstantService } from '@app/_services';
import { ApiResponse } from '@app/_models';
import { Feature } from '@app/_components/property/feature';
import { FeatureService } from '@app/_components/property/feature';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { PercentageValuesPositive, PercentageValuesNegative, PercentageValuesPositiveAndNegative } from '../../../_helpers/constants';
import { RateBucketsService } from '../rate-bucket/rate-bucket.service';
import { RateBucket } from '../rate-bucket/rate-bucket';
import { RateSeason } from '../rate-season/rate-season';
import { RateSeasonService } from '../rate-season/rate-season.service';

@Component({
    selector: 'app-rate-detail-bulk-edit',
    templateUrl: './rate-detail-bulk-edit.component.html',
    styleUrls: ['./rate-detail-bulk-edit.component.css'],
    standalone: false
})
export class RateDetailBulkEditComponent implements OnInit
{
  locationIds: any[];

  constructor(
    private currencyPipe: CurrencyPipe,
    private rateSeasonService: RateSeasonService,
    private rateBucketService: RateBucketsService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private formBuilder: UntypedFormBuilder,
    private constantService: ConstantService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data)
  {
    this.formTitle = data.title,
      this.rateSeason = data.rateSeason,
      this.formAction = data.formAction,
      this.locationIds = this.constantService.locations;
  }


  @Input() propertyId: number;
  @Input() rateSeason: RateSeason;
  @Input() rate: any;
  @Input() updateBulkEdit: boolean = false; // Just to call ngOnChanges
  @Output() doBulkEditCB = new EventEmitter<any>();


  // data
  apiResponse: ApiResponse;
  rateSeasonId: number;
  rateBucketId: number;
  rateBuckets: any;
  percentageValuesPositive: any = PercentageValuesPositive
  percentageValuesNegative: any = PercentageValuesNegative
  percentageValuesPositiveAndNegative: any = PercentageValuesPositiveAndNegative
  yieldMaxSelectedProperty: any; // Selected property from tape chart
  yieldMaxSelectedStartDate: any; // Selected date from tape chart

  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAction: string;
  formLabels = [];
  formReadOnly = false;
  formAlert: string;
  formTitle: string;
  favoriteSeason: string;
  updateSeasonList: boolean = false;


  rateBucketTypes = [
    { value: 1, name: 'Auto' },
    { value: 2, name: 'Manual' }
  ];


  seasonCategories = [
    { value: 1, name: 'Low' },
    { value: 2, name: 'Low-Medium' },
    { value: 3, name: 'Medium' },
    { value: 4, name: 'Medium-High' },
    { value: 5, name: 'High' },
  ];


  discountAlorithms = [
    { value: '1', name: 'Straight Line' },
  ];




  validationMessages = {
    rateSeasonId: [],
    rateBucketId: [{ type: 'required', message: 'Required' }],
    locationId: [],
    name: [{ type: 'required', message: 'Required' }],
    rateBucketName: [],
    description: [{ type: 'required', message: 'Required' }],
    publicRateDesc: [],
    type: [{ type: 'required', message: 'Required' }],
    startDate: [{ type: 'required', message: 'Required' }],
    endDate: [{ type: 'required', message: 'Required' }],
    listPriceAMT: [],
    listPriceAMTExpDate:[],
    listPriceAdjustPCT: [],
    mondayAdjPCT: [],
    tuesdayAdjPCT: [],
    wednesdayAdjPCT: [],
    thursdayAdjPCT: [],
    fridayAdjPCT: [],
    saturdayAdjPCT: [],
    sundayAdjPCT: [],
    listPriceAdjustAMT: [{ type: 'required', message: 'Required' }],
    floorRateManagerAMT: [],
    floorRateOwnerAMT: [],
    category: [{ type: 'required', message: 'Required' }],
    expectedOccupancyPCT: [{ type: 'required', message: 'Required' }],
    maxDiscountPCT: [],
    discountLookForwardDays: [],
    discountLookForwardHeadlineDays: [],
    discountLookForwardHeadlineMinNightsDays: [],
    discountCombinationDays: [],
    discountAlorithm: [],
    minStayExpectedNTS: [],
    maxStayExpectedNTS: [],
    avgStayBySeasonNTS: [],
    shortTermGapMultiplierPCT: [],
    shortTermGapPenaltyPCT: [],
    shortTermGapMinNumNightsRevNTS: [],
    longTermGapMultiplierPCT: [],
    longTermGapPenaltyPCT: [],
    longTermGapEmptyMultiplierPCT: [],
    connectingFrontOrBackMultiplierPCT: [],
    connectingFrontAndBackMultiplierPCT: [],
    lengthOfStayDiscountFactorOffset: [],
    updateRateFor:[],
    listPriceAMTByPCT:[],
    minStayExpectedNTSByPCT:[],
    maxStayExpectedNTSByPCT:[],
    avgStayBySeasonNTSByPCT:[],
    floorRateManagerAMTByPCT:[],
    floorRateOwnerAMTByPCT:[],
    expectedOccupancyPCTByPCT:[],
    listPriceAdjustAMTByPCT:[],
    listPriceAdjustPCTByPCT:[],
    mondayAdjPCTByPCT:[],
    tuesdayAdjPCTByPCT:[],
    wednesdayAdjPCTByPCT:[],
    thursdayAdjPCTByPCT:[],
    fridayAdjPCTByPCT:[],
    saturdayAdjPCTByPCT:[],
    sundayAdjPCTByPCT:[],
    discountLookForwardDaysByPCT:[],
    maxDiscountPCTByPCT:[],
    connectingFrontOrBackMultiplierPCTByPCT:[],
    connectingFrontAndBackMultiplierPCTByPCT:[],
    lengthOfStayDiscountFactorOffsetByPCT:[],
    shortTermGapMultiplierPCTByPCT:[],
    shortTermGapPenaltyPCTByPCT:[],
    longTermGapMultiplierPCTByPCT:[],
    longTermGapPenaltyPCTByPCT:[],
    discountLookForwardHeadlineDaysByPCT:[],
    discountLookForwardHeadlineMinNightsDaysPCT:[],
    shortTermGapMinNumNightsRevNTSPCT:[],
    expectedOccupancyPCTExpDate: [],
    longTermGapEmptyMultiplierPCTByPCT:[],
    listPriceAdjustPCTExpDate:[],
    mondayAdjPCTExpDate:[],
    tuesdayAdjPCTExpDate:[],
    wednesdayAdjPCTExpDate:[],
    thursdayAdjPCTExpDate:[],
    fridayAdjPCTExpDate:[],
    saturdayAdjPCTExpDate:[],
    sundayAdjPCTExpDate:[],
    listPriceAdjustAMTExpDate:[],
    floorRateManagerAMTExpDate:[],
    floorRateOwnerAMTExpDate:[],
    maxDiscountPCTExpDate:[],
    discountLookForwardDaysExpDate:[],
    discountLookForwardHeadlineDaysExpDate:[],
    discountLookForwardHeadlineMinNightsDaysExpDate:[],
    minStayExpectedNTSExpDate:[],
    maxStayExpectedNTSExpDate:[],
    avgStayBySeasonNTSExpDate:[],
    shortTermGapMultiplierPCTExpDate:[],
    shortTermGapPenaltyPCTExpDate:[],
    shortTermGapMinNumNightsRevNTSExpDate:[],
    longTermGapMultiplierPCTExpDate:[],
    longTermGapPenaltyPCTExpDate:[],
    longTermGapEmptyMultiplierPCTExpDate:[],
    connectingFrontOrBackMultiplierPCTExpDate:[],
    connectingFrontAndBackMultiplierPCTExpDate:[],
    lengthOfStayDiscountFactorOffsetExpDate:[],
    doNotApplyAdjustmentOnRate:[],
  };

  ngOnInit()
  {
    this.formBuild();
    this.loadRateBuckets();

    if (this.rateSeason)
    {
      this.rateSeasonId = this.rateSeason.rateSeasonId;
      this.form1.patchValue(this.rateSeason);
    }
    if(this.rate)
    {
      //Pass values to search component to show property and date default selected
      this.yieldMaxSelectedProperty = this.rate.propertyId;
      this.yieldMaxSelectedStartDate = this.rate.analyzedDate;
    }
  }


  onSearchFormChange(searchForm: any)
  {
    if(this.form1.get('updateRateFor').value == 'RS')
    {
      this.form1.patchValue({
        reportSearchApi: searchForm
      });
      this.updateSeasonList = !this.updateSeasonList;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Reload the page when some change occured
    this.ngOnInit();
	}

  onSearchSubmit(data: any)
  {
    if(this.form1.get('updateRateFor').value == 'RS')
    {
      let seasonIdList = [];
      let seasonNameList = [];
      data.forEach(season => {
        seasonIdList.push(season.rateSeasonId);
        seasonNameList.push(season.name + " " + season.startDate);
      });
      //pass season id list to season list component to filter the result
      this.form1.patchValue({
        seasonList: seasonIdList
      });
      //season name list to show on submit confirmation dialog with values which are going to be updated
      data = seasonNameList;
    }
    else 
    {
      this.form1.patchValue({
        reportSearchApi: data
      });
    }
    let a = JSON.stringify(this.getUpdatedInputValues());
    let b = JSON.stringify(this.getUpdatedConditionalValues());

    this.confirmationService.confirm({
      message: 'Are you sure you want to update<br><br><b>' + a + '<br><br>Where<br><br><b>' + JSON.stringify(data) + '</b>?',
      // message: 'Are you sure you want to update?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () =>
      {
        this.formSubmit();
        // prevent muliple popups for some reason
        this.confirmationService.close();
      },
      reject: () =>
      {
        this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Bulk Update canceled.', life: 3000 });

        // prevent muliple popups for some reason
        this.confirmationService.close();
      }
    });
  }



  formSubmit()
  {
    try
    {
      console.log('bulk update: ' + JSON.stringify(this.form1.value));
      // stop here if form is invalid
      if (this.form1.invalid)
      {
        console.log('Invalid ');
        return;
      }

      this.formLoading = true;
      this.rateSeasonService.bulkUpdate(this.form1.value)
        .subscribe(
          res =>
          {
            this.formLoading =false;
            console.log('rateSeason-add SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message, life: 5000 });
            this.doBulkEditCB.emit(res.message);
          },
          err =>
          {
            console.log('rateSeason-add FAIL: ' + JSON.stringify(err));
            this.formLoading = false;
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });

    } catch (error)
    {
      this.formLoading = false;
      this.alertService.error(error);
    }
  }


  resetForm()
  {
    this.form1.reset();
    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Form Reset Successfully ' });
  }

  increasePercentage(percentagefield, step) {
		let updatedValue = this.form1.value[percentagefield] + step;
		this.form1.controls[percentagefield].setValue(updatedValue);
	}
	decreasePercentage(percentagefield, step){
		let updatedValue = this.form1.value[percentagefield] - step;
		this.form1.controls[percentagefield].setValue(updatedValue);
	}

  loadRateBuckets()
  {
    try
    {
      this.rateBucketService.findAll()
        .subscribe(
          res =>
          {
            this.rateBuckets = res.data.rateBuckets;
          },
          err =>
          {
            console.log('loadRateBuckets-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });

    } catch (error)
    {
      this.alertService.error(error);
    }
  }

  formBuild()
  {
		/**
				   *
				   *
				   *
				   * FORM
				   *
				   */

    this.form1 = this.formBuilder.group({
      rateBucketId: [],
      createDate: [],
      lastUpdate: [],
      name: [],
      rateBucketName: [],
      description: [],
      publicRateDesc: [],
      type: [],
      startDate: [],
      endDate: [],
      listPriceAMT: [],
      listPriceAdjustPCT: [],
      mondayAdjPCT: [],
      mondayAdjPCTByPCT:[],
      mondayAdjPCTExpDate:[],
      tuesdayAdjPCT: [],
      tuesdayAdjPCTByPCT:[],
      tuesdayAdjPCTExpDate:[],
      wednesdayAdjPCT: [],
      wednesdayAdjPCTByPCT:[],
      wednesdayAdjPCTExpDate:[],
      thursdayAdjPCT: [],
      thursdayAdjPCTByPCT:[],
      thursdayAdjPCTExpDate:[],
      fridayAdjPCT: [],
      fridayAdjPCTByPCT:[],
      fridayAdjPCTExpDate:[],
      saturdayAdjPCT: [],
      saturdayAdjPCTByPCT:[],
      saturdayAdjPCTExpDate:[],
      sundayAdjPCT: [],
      sundayAdjPCTByPCT:[],
      sundayAdjPCTExpDate:[],
      listPriceAMTExpDate:[],
      listPriceAdjustAMT: [],
      floorRateManagerAMT: [],
      floorRateOwnerAMT: [],
      category: [],
      expectedOccupancyPCT: [],
      maxDiscountPCT: [],
      discountLookForwardDays: [],
      discountLookForwardHeadlineDays: [],
      discountLookForwardHeadlineMinNightsDays: [],
      discountCombinationDays: [],
      discountAlorithm: [],
      minStayExpectedNTS: [],
      maxStayExpectedNTS: [],
      avgStayBySeasonNTS: [],
      shortTermGapMultiplierPCT: [],
      shortTermGapPenaltyPCT: [],
      shortTermGapMinNumNightsRevNTS: [],
      longTermGapMultiplierPCT: [],
      longTermGapPenaltyPCT: [],
      longTermGapEmptyMultiplierPCT: [],
      connectingFrontOrBackMultiplierPCT: [],
      connectingFrontAndBackMultiplierPCT: [],
      lengthOfStayDiscountFactorOffset: [],
      reportSearchApi: [],
      seasonList:[],
      updateRateFor:["RS"],
      listPriceAMTByPCT:[],
      minStayExpectedNTSByPCT:[],
      maxStayExpectedNTSByPCT:[],
      avgStayBySeasonNTSByPCT:[],
      floorRateManagerAMTByPCT:[],
      floorRateOwnerAMTByPCT:[],
      expectedOccupancyPCTByPCT:[],
      listPriceAdjustAMTByPCT:[],
      listPriceAdjustPCTByPCT:[],
      discountLookForwardDaysByPCT:[],
      maxDiscountPCTByPCT:[],
      connectingFrontOrBackMultiplierPCTByPCT:[],
      connectingFrontAndBackMultiplierPCTByPCT:[],
      lengthOfStayDiscountFactorOffsetByPCT:[],
      shortTermGapMultiplierPCTByPCT:[],
      shortTermGapPenaltyPCTByPCT:[],
      longTermGapMultiplierPCTByPCT:[],
      longTermGapPenaltyPCTByPCT:[],
      discountLookForwardHeadlineDaysByPCT:[],
      discountLookForwardHeadlineMinNightsDaysPCT:[],
      shortTermGapMinNumNightsRevNTSPCT:[],
      longTermGapEmptyMultiplierPCTByPCT:[],
      listPriceAdjustPCTExpDate:[],
      expectedOccupancyPCTExpDate: [],
      listPriceAdjustAMTExpDate:[],
      floorRateManagerAMTExpDate:[],
      floorRateOwnerAMTExpDate:[],
      maxDiscountPCTExpDate:[],
      discountLookForwardDaysExpDate:[],
      discountLookForwardHeadlineDaysExpDate:[],
      discountLookForwardHeadlineMinNightsDaysExpDate:[],
      minStayExpectedNTSExpDate:[],
      maxStayExpectedNTSExpDate:[],
      avgStayBySeasonNTSExpDate:[],
      shortTermGapMultiplierPCTExpDate:[],
      shortTermGapPenaltyPCTExpDate:[],
      shortTermGapMinNumNightsRevNTSExpDate:[],
      longTermGapMultiplierPCTExpDate:[],
      longTermGapPenaltyPCTExpDate:[],
      longTermGapEmptyMultiplierPCTExpDate:[],
      connectingFrontOrBackMultiplierPCTExpDate:[],
      connectingFrontAndBackMultiplierPCTExpDate:[],
      lengthOfStayDiscountFactorOffsetExpDate:[],
      doNotApplyAdjustmentOnRate:[],
    });
  }

  updateExpDate(field, days)
	{
		if(days == 'N')
		{
			let date = new Date();
			date.setFullYear(3000, 0, 1);
			date = this.addLocalTimeToDateTime(date);
			this.form1.controls[field].setValue(date);
		}
		else
		{
			let date = new Date();
			date.setDate( date.getDate() + days );
			date = this.addLocalTimeToDateTime(date);
			this.form1.controls[field].setValue(date);
		}
	}
  

  // not used below but kept for reference.
  getUpdatedInputValues()
  {
    const updatedFormValues = {};
    this.form1['_forEachChild']((control, name) =>
    {

      if (control.dirty && !name.startsWith('where'))
      {
        updatedFormValues[name] = control.value;
      }
    });
    return (updatedFormValues);
  }

  getUpdatedConditionalValues()
  {
    const updatedFormValues = {};
    this.form1['_forEachChild']((control, name) =>
    {
      if (control.dirty && name.startsWith('where'))
      {
        console.log(name + ' ' + control.value);
        updatedFormValues[name] = control.value;
      }
    });
    return (updatedFormValues);
  }

  /**
	 * Add time plus local time GMT hours as http request change time to UTC time
	 * @param datetime
	 * @returns
	 */
	addLocalTimeToDateTime(datetime) {
		return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
	}

}



